import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { BenefitBucksCompleteWallet } from '../../models/BenefitBucks';

interface IBenefitBucksService {
  getWallet: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<BenefitBucksCompleteWallet>>;
}

export const benefitBucksService: IBenefitBucksService = {
  getWallet(axiosConfig) {
    return ajax.get<BenefitBucksCompleteWallet>(
      `${config.benefitApiUrl}/cashclub/wallet`,
      axiosConfig,
    );
  },
};
